import React, { } from 'react'

import { IonToolbar, IonTitle, IonButton, IonIcon, IonButtons } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';

interface Props {
  title: string,
  onClose: () => any
}


const ToolbarModal: React.FC<Props> = (props: Props) => {
  return (
    <IonToolbar>
      <IonTitle>{props.title}</IonTitle>
      <IonButtons slot="secondary">
        <IonButton onClick={() => props.onClose()}>
          <IonIcon slot="icon-only" icon={closeOutline} />
        </IonButton>
      </IonButtons>
    </IonToolbar>
  )
}

export default ToolbarModal;
